import Modal from "components/Modal/Modal";
import cx from "classnames";
import React from "react";
import { getAddress } from "ethers/lib/utils";
import { Trans, t } from "@lingui/macro";
import { getTokenInfo } from "domain/tokens/utils";
import { USD_DECIMALS } from "lib/legacy";
import { formatAmount } from "lib/numbers";
import { TokenUtils } from "components/TokenUtils";

const ClosedPositionsDetailsModal = ({ open, setIsVisible, infoTokens, position }) => {
  if (position) {
    const indexToken = getTokenInfo(infoTokens, getAddress(position.token));

    return (
      <Modal
        isVisible={open}
        setIsVisible={setIsVisible}
        label={
          <div className="tailwind isolate flex items-center justify-center gap-2.5">
            <TokenUtils.Logo token={indexToken} className="w-[3rem]"></TokenUtils.Logo>

            <div className="flex flex-col items-start">
              <div className="text-[1.8rem] text-textColor font-bold">{TokenUtils.getSymbol(indexToken)}</div>
              {position.leverage && (
                <div className="text-[1.2rem] font-normal text-inactive">
                  {"Leverage " + formatAmount(position.leverage, 4, 2, true)}x&nbsp;
                </div>
              )}
            </div>
          </div>
        }
      >
        <div className="tailwind isolate flex flex-col gap-4 text-[1.4rem] text-inactive">
          <div className="h-px w-full bg-border mb-5" />
          <div className="flex items-center justify-between">
            <div>
              <Trans>Side</Trans>
            </div>
            <span className={cx({ long: position.isLong, short: !position.isLong })}>
              {position.isLong ? t`Long` : t`Short`}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <Trans>Size</Trans>
            </div>
            <div className="text-textColor">${formatAmount(position.size, USD_DECIMALS, 4, true)}</div>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <Trans>Closing Price</Trans>
            </div>
            <div className="text-textColor">
              ${formatAmount(position.exitPrice, USD_DECIMALS, indexToken?.priceDecimals, true)}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <Trans>Entry Price</Trans>
            </div>
            <div className="text-textColor">
              ${formatAmount(position.entryPrice, USD_DECIMALS, indexToken?.priceDecimals, true)}
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <Trans>PnL</Trans>
            </div>
            <div className="text-textColor">
              <span className={position.realisedPnl.gt(0) ? "positive" : "negative"}>
                ${formatAmount(position.realisedPnl, USD_DECIMALS, indexToken?.priceDecimals, true)}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  return null;
};

export default ClosedPositionsDetailsModal;
